import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { stringify as stringifyQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../misc";
import {
  LanguageCodeEnum,
  LoginPopupTranslationInput
} from "../../types/globalTypes";
import TranslationsLoginPopupPage, {
  fieldNames
} from "../components/TranslationsLoginPopupPage";
import { TypedUpdateLoginPopupTranslations } from "../mutations";
import { TypedLoginPopupTranslationDetails } from "../queries";
import { UpdateLoginPopupTranslations } from "../types/UpdateLoginPopupTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsLoginPopupQueryParams {
  activeField: string;
}
export interface TranslationsLoginPopupProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsLoginPopupQueryParams;
}

const TranslationsLoginPopup: React.FC<TranslationsLoginPopupProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdateLoginPopupTranslations) => {
    if (data.loginpopupTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedLoginPopupTranslationDetails
      variables={{ id, language: languageCode }}
    >
      {pageHeaderTranslations => (
        <TypedUpdateLoginPopupTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: LoginPopupTranslationInput = {};
              if (field === fieldNames.title) {
                input.title = data;
              } else if (field === fieldNames.subTitle) {
                input.subTitle = data;
              } else if (field === fieldNames.pcUrl) {
                input.pcUrl = data;
              } else if (field === fieldNames.mbUrl) {
                input.mbUrl = data;
              } else if (field === fieldNames.coupon) {
                input.coupon = data;
              } else if (field === fieldNames.Button) {
                input.Button = data;
              } else if (field === fieldNames.couponCode) {
                input.couponCode = data;
              }
              updateTranslations({
                variables: {
                  id,
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsLoginPopupPage
                activeField={params.activeField}
                disabled={
                  pageHeaderTranslations.loading ||
                  updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(lang, TranslatableEntities.loginPopup, id)
                  )
                }
                onSubmit={handleSubmit}
                loginPopup={maybe(
                  () => pageHeaderTranslations.data.loginpopupById
                )}
              />
            );
          }}
        </TypedUpdateLoginPopupTranslations>
      )}
    </TypedLoginPopupTranslationDetails>
  );
};
TranslationsLoginPopup.displayName = "TranslationsLoginPopup";
export default TranslationsLoginPopup;
